import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import CustomPluginEnablerCommand from './custompluginenablercommand';
import CustomPluginEnablerEditing from './custompluginenablerediting';

export default class CustomPluginEnabler extends Plugin {
    static get requires() {
        return [CustomPluginEnablerEditing, CustomPluginEnablerCommand];
    }

    static get pluginName() {
        return 'CustomPluginEnabler';
    }
}